<template>
  <div class="flex flex-col items-center justify-center px-4">
    <p class="font-semibold text-lg text-BLACK pt-5">Select Token</p>
    <div class="rounded-lg bg-WHITE flex flex-row p-3 gap-3 items-center w-full mt-8">
      <font-awesome-icon class="black-icon" icon="fa-solid fa-magnifying-glass" />
      <input
        v-model="message"
        placeholder="Search token"
        class="placeholder-[##8B8B8B] bg-WHITE border-0 focus:outline-none text-sm text-BLACK w-full"
      />
    </div>
    <div class="flex flex-col gap-3 w-full pt-6">
      <token-item
        v-for="(token, index) in tokens"
        :selected="token.selected"
        :token="token"
        @update:selected="selecToken(index)"
      ></token-item>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import TokenItem from '../TokenItem.vue'
const massage = ref('')

const props = defineProps({
  tokens: {
    type: Array,
    required: true
  }
})

const emit = defineEmits(['update:selected'])

const selecToken = (index) => {
  props.tokens.forEach((token, i) => {
    token.selected = i === index
    if (token.selected) {
      emit('selected', token)
    }
  })
}
</script>
